import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({

  selector: 'app-can-dash',

  templateUrl: './can-dash.component.html',

  styleUrls: ['./can-dash.component.css', '../../../styles/styles-dark.css']

})

export class CanDashComponent implements OnInit {

  Id: any;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.Id = this.route.parent?.snapshot.params['id']


  }

}
